import { client } from "./api";
import {
  IChangePasswordProps,
  IUser,
  IUserCreateServiceProps,
  IUserServiceUpdateProps,
} from "interfaces/User";
import {
  IFilterData,
  IGetFilterProps,
  IGetOneFilterProps,
  IGetUniqueData,
} from "interfaces/FilterProps";

type IForgetPasswordProps = {
  email: string;
  password: string;
};

export async function getUsersService({
  order,
  relations,
  skip,
  take,
  where,
}: IGetFilterProps<IUser>): Promise<IFilterData<IUser>> {
  const api = client();
  const response = await api.get<IFilterData<IUser>>("users", {
    params: {
      take,
      skip,
      relations: JSON.stringify(relations),
      order: JSON.stringify(order),
      where: JSON.stringify(where),
    },
  });
  return response.data;
}

export async function getCurrentUser(): Promise<IUser | undefined> {
  try {

    const api = client();
    const response = await api.get("users/me");
    return response.data.item;
  } catch (error) {
      console.log({error})
  }
}

export async function getUserService({
  where,
}: IGetOneFilterProps<IUser>): Promise<IGetUniqueData<IUser>> {
  const api = client();
  const response = await api.get<IGetUniqueData<IUser>>(`users/one`, {
    params: {
      where,
      relations: {
        schedule: true,
        role: true,
      },
    },
  });
  return response.data;
}

export async function createUsersService({
  password,
  cpf,
  email,
  name,
  rg,
  role,
  mondayEntry,
  mondayExit,
  tuesdayEntry,
  tuesdayExit,
  wednesdayEntry,
  wednesdayExit,
  thursdayEntry,
  thursdayExit,
  fridayEntry,
  fridayExit,
  saturdayEntry,
  saturdayExit,
  sundayEntry,
  sundayExit,
  schedule,
}: IUserCreateServiceProps) {
  const api = client();
  if (schedule) {
    const response = await api.post("users", {
      user: {
        password,
        cpf,
        email,
        name,
        rg,
        role,
        type: 1,
      },
      schedule: {
        mondayEntry,
        mondayExit,
        tuesdayEntry,
        tuesdayExit,
        wednesdayEntry,
        wednesdayExit,
        thursdayEntry,
        thursdayExit,
        fridayEntry,
        fridayExit,
        saturdayEntry,
        saturdayExit,
        sundayEntry,
        sundayExit,
      },
    });
    return response.data;
  }
  const response = await api.post("users", {
    user: {
      password,
      cpf,
      email,
      name,
      rg,
      role,
      type: 1,
    },
  });
  return response.data;
}

export async function updateUsersService({
  user,
  schedule,
}: IUserServiceUpdateProps) {
  const api = client();
  const response = await api.patch("users", {
    user,
    schedule,
  });
  return response.data;
}
type user = {
  password?: string;
  cpf?: string;
  email?: string;
  name?: string;
  rg?: string;
  id?: string;
};
export async function updateProfileService(user: user) {
  const api = client();

  const response = await api.patch("users", {
    user,
  });
  return response.data;
}

export async function activeUsersService(id: string) {
  const api = client();
  const response = await api.post(`users/${id}`);
  return response.data;
}

export async function deleteUsersService(id: string) {
  const api = client();
  const response = await api.delete(`users/${id}`);
  return response.data;
}

export async function forgetPasswordService({
  email,
  password,
}: IForgetPasswordProps) {
  const api = client();
  const response = await api.post("users/forget", {
    email,
    newPassword: password,
  });
  return response.data;
}

export async function changePasswordService({
  newPassword,
  password,
}: IChangePasswordProps): Promise<IGetUniqueData<string>> {
  const api = client();
  const response = await api.post("users/password", {
    newPassword,
    password,
  });
  return response.data;
}
